import axios from 'axios';
import { AxiosRequestTimeout } from './PortalConfig';

export const baseURL = `${import.meta.env.VITE_API_URL}${import.meta.env.VITE_ENVIRONMENT === 'local' ? '/api' : ''}`;

const Api = axios.create({
  baseURL,
  withCredentials: true,
  withXSRFToken: true, // <-- important for cross-origin Axios 1.x
  timeout: AxiosRequestTimeout,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,PATCH,DELETE,PUT,OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Requested-With, X-Auth-Token, content-type',
    'X-Impersonated-Administrator': `${sessionStorage.getItem('impersonateId') || ''}`,
  },
});

Api.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers['X-Impersonated-Administrator'] = `${sessionStorage.getItem('impersonateId') || ''}`;
  return config;
});

/**
 * 401 handler
 */
Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.data) {
        switch (error.response.status) {
          case 401:
            // eslint-disable-next-line no-console
            console.log('AuthContext: Session is invalid!');
            localStorage.removeItem('expires');
            sessionStorage.removeItem('impersonateId');
            // TODO: navigate a session expired page first?
            window.location.href = `${import.meta.env.VITE_SAML_URL}`;
            break;
          default:
            return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
    return error;
  },
);
export default Api;
